import React from "react";

import { Dialog } from 'primereact/dialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';

import Card from 'react-bootstrap/Card';

import ExcelJS from "exceljs";
import saveAs from "file-saver";

import { RiskLevels, ConsequenceLevels, ProbabilityLevels } from './RiskLevels'

import UserContext from '../context/UserContext';


class RiskReportDialog extends React.Component {

	static contextType = UserContext;

	state = {
		reportName: '',
		fromDate: new Date(),
		toDate: new Date(),
		riskList: [],
	};


	componentDidMount() {
		
		var currentDate = new Date(this.state.toDate.getTime());
		this.setState({ riskList: this.props.riskList });
		if (Object.prototype.toString.call(this.props.toDate) === "[object Date]") {
			this.setState({ toDate: new Date(this.props.toDate.getTime()) });

			currentDate = new Date(this.props.toDate.getTime());
			currentDate.setFullYear(currentDate.getFullYear() - 1);
			this.setState({ fromDate: currentDate });
		} else {
			currentDate.setFullYear(currentDate.getFullYear() - 1);
			this.setState({ fromDate: currentDate });
		}
		 
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {
			this.setState({ riskList: this.props.riskList });
			if (Object.prototype.toString.call(this.props.toDate) === "[object Date]") {
				this.setState({ toDate: new Date(this.props.toDate.getTime()) });
				
				var currentDate = this.props.toDate;
				currentDate.setFullYear(currentDate.getFullYear() - 1);
				this.setState({ fromDate: currentDate });
			}			
		}
	}


	fetchReport() {	
		this.setState({ isLoadingData: true });
		var reportReuest = { riskList: this.state.riskList, name: this.state.reportName, fromDate: this.state.fromDate, toDate: this.state.toDate };
		
		fetch('api/Report/GetRiskReport', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(reportReuest) })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.excelExport(data);
				this.closeDialog();
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoadingData: false });
			})
	}


	closeDialog() {
		if (this.props.onClose != null) {
			this.props.onClose(false);
			this.setState({ reportName: '', fromDate: new Date(), toDate: new Date(), riskList: [] });
		}
	}



	excelExport(riskReport) {
		var ExcelJSWorkbook = new ExcelJS.Workbook();
		
		var reportName = this.state.reportName;

		this.riskListPage(ExcelJSWorkbook, riskReport);
		this.riskMatrix(ExcelJSWorkbook, riskReport);
		this.actionSummary(ExcelJSWorkbook, riskReport);
		this.riskDetails(ExcelJSWorkbook, riskReport);
		//worksheet.views = [{ state: "frozen", ySplit: 2 }];

		//worksheet.properties.outlineProperties = {
		//	summaryBelow: false,
		//	summaryRight: false
		//};
	
		//if (list[i][fieldName] instanceof Date) {
		//	cell.numFmt = 'yyyy-mm-dd';
		//}

		//Save excel file	
		ExcelJSWorkbook.xlsx.writeBuffer().then(function (buffer) {
			saveAs(
				new Blob([buffer], { type: "application/octet-stream" }),
				reportName + '.xlsx'
			);
		});
	}

	riskMatrix(ExcelJSWorkbook, riskReport) {
		var worksheet = ExcelJSWorkbook.addWorksheet("Heat map");

		worksheet.views = [{
			showGridLines: false
		}];

		worksheet.getColumn(1).width = 13;
		worksheet.getColumn(2).width = 13;

		var currentRow = worksheet.addRow();
		var currentRow2;
	
		for (var i = ConsequenceLevels.length - 1; i >= 0; i--) {
			currentRow = worksheet.addRow();
			currentRow.height = 20;

			currentRow.getCell(2).value = ConsequenceLevels[i].text;
			currentRow.getCell(2).alignment = { vertical: 'middle', horizontal: 'center' };
			currentRow.getCell(2).font = { bold: true };
			currentRow.getCell(2).border = {
				top: { style: 'thin' },
				left: { style: 'thin' },
				right: { style: 'thin' }
			};

			currentRow2 = worksheet.addRow();
			currentRow2.height = 40;
			currentRow2.getCell(2).alignment = { vertical: 'middle', horizontal: 'center' };
			currentRow2.getCell(2).font = { bold: true };
			currentRow2.getCell(2).border = {
				left: { style: 'thin' },
				bottom: { style: 'thin' },
				right: { style: 'thin' }
			};

			for (var j = 0; j < ProbabilityLevels.length; j++) {
				currentRow.getCell(j + 3).value = RiskLevels[j][i].label;
				currentRow.getCell(j + 3).alignment = { vertical: 'middle', horizontal: 'center' };
				var cellColor = '88' + RiskLevels[j][i].color.slice(1);
				var cellBg = 'FF' + RiskLevels[j][i].bgColor.slice(1);
				currentRow.getCell(j + 3).fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: cellBg }
				};
				currentRow.getCell(j + 3).font = {
					color: { argb: cellColor }
				};

				var risksInSquare = 0;
				for (let k = 0; k < riskReport.length; k++) {
					var risk = riskReport[k];					
					if (risk.probability - 1 === j && risk.consequence - 1 === i) {
						risksInSquare++;
					}
				}
				currentRow2.getCell(j + 3).fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: cellBg }
				};
				if (risksInSquare > 0) {
					var cellColorAccent = 'FF' + RiskLevels[j][i].color.slice(1);
					currentRow2.getCell(j + 3).font = {
						color: { argb: cellColorAccent },
						bold: true,
						size:18
					}; 
					currentRow2.getCell(j + 3).value = risksInSquare;
					currentRow2.getCell(j + 3).alignment = { vertical: 'middle', horizontal: 'center' };
				}
			}
		}

		currentRow = worksheet.addRow();
		currentRow.height = 50;
		for (var k = 0; k < ProbabilityLevels.length; k++) {
			worksheet.getColumn(k + 3).width = 15;
			currentRow.getCell(k + 3).value = ProbabilityLevels[k].text;
			currentRow.getCell(k + 3).font = { bold: true };
			currentRow.getCell(k + 3).alignment = { vertical: 'middle', horizontal: 'center' };
			currentRow.getCell(k + 3).border = {
				top: { style: 'thin' },
				left: { style: 'thin' },
				bottom: { style: 'thin' },
				right: { style: 'thin' }
			};
		}

		currentRow = worksheet.addRow();
		currentRow.height = 50;
		worksheet.mergeCells(ConsequenceLevels.length*2 + 3, 3, ConsequenceLevels.length*2 + 3, ProbabilityLevels.length+2);
		currentRow.getCell(ConsequenceLevels.length + 2).value = 'Probability';
		currentRow.getCell(ConsequenceLevels.length + 2).font = { bold: true };		
		currentRow.getCell(ConsequenceLevels.length + 2).alignment = { vertical: 'middle', horizontal: 'center' };

		worksheet.mergeCells(2, 1, ConsequenceLevels.length*2 + 1, 1);
		worksheet.getCell('A2').value = 'Consequence';
		worksheet.getCell('A2').font = { bold: true };	
		worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center', textRotation: 90 };	
	}

	actionSummary(ExcelJSWorkbook, riskReport) {
		var worksheet = ExcelJSWorkbook.addWorksheet("Action summary");

		worksheet.views = [{
			showGridLines: false
		}];

		worksheet.getColumn(1).width = 10;
		worksheet.getColumn(2).width = 35;
		worksheet.getColumn(3).width = 65;
		worksheet.getColumn(4).width = 16;
		worksheet.getColumn(5).width = 16;
		worksheet.getColumn(6).width = 16;

		worksheet.getCell('A1').value = "Risk ID"
		worksheet.getCell('A1').font = { bold: true };
		worksheet.getCell('A1').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFC0C0C0' }
		};
		worksheet.getCell('A1').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.getCell('B1').value = "Risk"
		worksheet.getCell('B1').font = { bold: true };
		worksheet.getCell('B1').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFC0C0C0' }
		};
		worksheet.getCell('B1').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.getCell('C1').value = "Mitigation action"
		worksheet.getCell('C1').font = { bold: true };
		worksheet.getCell('C1').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFC0C0C0' }
		};
		worksheet.getCell('C1').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.getCell('D1').value = "Owner"
		worksheet.getCell('D1').font = { bold: true };
		worksheet.getCell('D1').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFC0C0C0' }
		};
		worksheet.getCell('D1').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.getCell('E1').value = "Deadline"
		worksheet.getCell('E1').font = { bold: true };
		worksheet.getCell('E1').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFC0C0C0' }
		};
		worksheet.getCell('E1').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.getCell('F1').value = "Status"
		worksheet.getCell('F1').font = { bold: true };
		worksheet.getCell('F1').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFC0C0C0' }
		};
		worksheet.getCell('F1').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};


		worksheet.getColumn(12).width = 55;

		var firstRowOfRisk = 2;

		for (let i = 0; i < riskReport.length; i++) {
			var risk = riskReport[i];

			for (var j = 0; j < risk.mitigationReports.length; j++) {
				const mitigation = risk.mitigationReports[j];
				var currentRow = worksheet.addRow();

				currentRow.getCell(1).value = risk.riskID;
				currentRow.getCell(1).border = {
					top: { style: 'thin' },
					left: { style: 'thin' },
					bottom: { style: 'thin' },
					right: { style: 'thin' }
				};
				currentRow.getCell(2).value = risk.name;
				currentRow.getCell(2).border = {
					top: { style: 'thin' },
					left: { style: 'thin' },
					bottom: { style: 'thin' },
					right: { style: 'thin' }
				};
				currentRow.getCell(3).value = mitigation.name;
				currentRow.getCell(3).border = {
					top: { style: 'thin' },
					left: { style: 'thin' },
					bottom: { style: 'thin' },
					right: { style: 'thin' }
				};
				currentRow.getCell(4).value = mitigation.responsible;
				currentRow.getCell(4).border = {
					top: { style: 'thin' },
					left: { style: 'thin' },
					bottom: { style: 'thin' },
					right: { style: 'thin' }
				};
				currentRow.getCell(5).value = mitigation.deadline.split('T')[0];
				currentRow.getCell(5).numFmt = 'yyyy-mm-dd';
				currentRow.getCell(5).border = {
					top: { style: 'thin' },
					left: { style: 'thin' },
					bottom: { style: 'thin' },
					right: { style: 'thin' }
				};
				currentRow.getCell(6).value = mitigation.status;
				currentRow.getCell(6).border = {
					top: { style: 'thin' },
					left: { style: 'thin' },
					bottom: { style: 'thin' },
					right: { style: 'thin' }
				};	

			}
			if (risk.mitigationReports.length > 0) {
				if (risk.mitigationReports.length > 1) {
					worksheet.mergeCells(firstRowOfRisk, 1, firstRowOfRisk + risk.mitigationReports.length - 1, 1);
					worksheet.getRow(firstRowOfRisk).getCell(1).alignment = { vertical: 'middle' };
					worksheet.mergeCells(firstRowOfRisk, 2, firstRowOfRisk + risk.mitigationReports.length - 1, 2);
					worksheet.getRow(firstRowOfRisk).getCell(2).alignment = { vertical: 'middle' };
				}
				firstRowOfRisk = firstRowOfRisk + risk.mitigationReports.length+1;
			}
			
		}
	}



	riskDetails(ExcelJSWorkbook, riskReport) {
		for (let i = 0; i < riskReport.length; i++) {
			var risk = riskReport[i];
			var worksheet = ExcelJSWorkbook.addWorksheet("Risk details - " + risk.riskID);

			worksheet.views = [{
				showGridLines: false
			}];

			worksheet.getColumn(1).width = 5;
			worksheet.getColumn(2).width = 21;
			worksheet.getColumn(3).width = 21;
			worksheet.getColumn(4).width = 21;
			worksheet.getColumn(5).width = 15;

			worksheet.mergeCells("B1:E1");
			worksheet.getRow(1).height = 23.25;
			worksheet.getCell('B1').font = { bold: true, size: 18 };
			worksheet.getCell('B1').value = risk.name;
			worksheet.getCell('B1').fill = {
				type: 'pattern',
				pattern: 'solid',
				fgColor: { argb: 'FFC5D9F1' }
			};

			var currentRow = worksheet.addRow();
			var currentRowIdx = worksheet.rowCount;
			currentRow.getCell(2).font = { bold: true };
			currentRow.getCell(2).value = "Risk owner";
			currentRow = worksheet.addRow();
			currentRow.getCell(2).value = risk.ownerName;

			currentRow = worksheet.addRow();	
			currentRow.getCell(2).font = { bold: true };
			currentRow.getCell(2).value = "Category";
			currentRow = worksheet.addRow();
			currentRow.getCell(2).value = risk.category;

			currentRow = worksheet.addRow();
			currentRow.getCell(2).font = { bold: true };
			currentRow.getCell(2).value = "Area/Process";
			currentRow = worksheet.addRow();
			currentRow.getCell(2).value = risk.process;

			currentRow = worksheet.addRow();
			currentRow.font = { bold: true };
			currentRow.getCell(2).value = "Probability";
			currentRow.getCell(3).value = "Consequence";
			currentRow.getCell(4).value = "Risk";
			currentRow = worksheet.addRow();

			currentRow.getCell(2).value = ProbabilityLevels[risk.probability - 1].text;
			currentRow.getCell(3).value = ConsequenceLevels[risk.consequence - 1].text;
			currentRow.getCell(4).value = RiskLevels[risk.probability - 1][risk.consequence - 1].label;
			var cellColor = 'FF' + RiskLevels[risk.probability - 1][risk.consequence - 1].color.slice(1);
			var cellBg = 'FF' + RiskLevels[risk.probability - 1][risk.consequence - 1].bgColor.slice(1);
			currentRow.getCell(4).fill = {
				type: 'pattern',
				pattern: 'solid',
				fgColor: { argb: cellBg }
			};
			currentRow.getCell(4).font = {
				color: { argb: cellColor }
			};
			currentRow = worksheet.addRow();

			currentRow = worksheet.addRow();
			currentRow.getCell(2).font = { bold: true };
			currentRow.getCell(2).value = "Description";
			currentRow = worksheet.addRow();
			currentRowIdx = worksheet.rowCount;
			worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
			currentRow.getCell(2).value = risk.description;
			currentRow.getCell(2).alignment = { wrapText: true };
			currentRow = worksheet.addRow();

			currentRow = worksheet.addRow();
			currentRow.getCell(2).font = { bold: true };
			currentRow.getCell(2).value = "Risk root cause";
			currentRow = worksheet.addRow();
			currentRowIdx = worksheet.rowCount;
			worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
			currentRow.getCell(2).value = risk.rootCause;
			currentRow.getCell(2).alignment = { wrapText: true };
			currentRow = worksheet.addRow();

			currentRow = worksheet.addRow();
			currentRow.getCell(2).font = { bold: true };
			currentRow.getCell(2).value = "Potential Consequences";
			currentRow = worksheet.addRow();
			currentRowIdx = worksheet.rowCount;
			worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
			currentRow.getCell(2).value = risk.potentialConsequences;
			currentRow.getCell(2).alignment = { wrapText: true };
			currentRow = worksheet.addRow();

			currentRow = worksheet.addRow();
			currentRow.getCell(2).font = { bold: true };
			currentRow.getCell(2).value = "Response plan";
			currentRow = worksheet.addRow();
			currentRowIdx = worksheet.rowCount;
			worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
			currentRow.getCell(2).value = risk.responsPlan;
			currentRow.getCell(2).alignment = { wrapText: true };
			currentRow = worksheet.addRow();

			currentRow = worksheet.addRow();
			currentRowIdx = worksheet.rowCount;
			//var endColumnIdx = worksheet.columnCount;

			//Mitigation actions
			for (var j = 0; j < risk.mitigationReports.length; j++){
				const mitigation = risk.mitigationReports[j];

				currentRow = worksheet.addRow();
				currentRow.height = 19;
				currentRowIdx = worksheet.rowCount; 
				worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
				currentRow.getCell(2).font = { bold: true, size: 14 };
				currentRow.getCell(2).value = "Mitigation action - " + mitigation.name;
				currentRow.getCell(2).fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'FFF2F2F2' }
				};
				currentRow = worksheet.addRow();

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Owner";
				currentRow.getCell(3).value = mitigation.responsible;

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Deadline";
				currentRow.getCell(3).value = mitigation.deadline.split('T')[0];
				currentRow.getCell(3).numFmt = 'yyyy-mm-dd';

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Status";
				currentRow.getCell(3).value = mitigation.status;

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Mitigation type";
				currentRow.getCell(3).value = mitigation.mitigationType;
				currentRow = worksheet.addRow();

				currentRow = worksheet.addRow();
				currentRow.font = { bold: true };
				currentRow.getCell(2).value = "Probability after";
				currentRow.getCell(3).value = "Consequence after";
				currentRow.getCell(4).value = "Risk after";
				currentRow = worksheet.addRow();

				currentRow.getCell(2).value = ProbabilityLevels[mitigation.probabilityAfter - 1].text;
				currentRow.getCell(3).value = ConsequenceLevels[mitigation.consequenceAfter - 1].text;
				currentRow.getCell(4).value = RiskLevels[mitigation.probabilityAfter - 1][mitigation.consequenceAfter - 1].label;
				cellColor = 'FF' + RiskLevels[mitigation.probabilityAfter - 1][mitigation.consequenceAfter - 1].color.slice(1);
				cellBg = 'FF' + RiskLevels[mitigation.probabilityAfter - 1][mitigation.consequenceAfter - 1].bgColor.slice(1);
				currentRow.getCell(4).fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: cellBg }
				};
				currentRow.getCell(4).font = {
					color: { argb: cellColor }
				};
				currentRow = worksheet.addRow();

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Description";
				currentRow = worksheet.addRow();
				currentRowIdx = worksheet.rowCount; 
				worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
				currentRow.getCell(2).value = mitigation.description;
				currentRow.getCell(2).alignment = { wrapText: true };
				currentRow = worksheet.addRow();

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Comments";
				currentRow = worksheet.addRow();
				currentRowIdx = worksheet.rowCount;
				worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
				currentRow.getCell(2).value = mitigation.comment;
				currentRow.getCell(2).alignment = { wrapText: true };
				currentRow = worksheet.addRow();
			}

			//Controls
			for (var j = 0; j < risk.controlReports.length; j++) {
				const control = risk.controlReports[j];

				currentRow = worksheet.addRow();
				currentRow.height = 19;
				currentRowIdx = worksheet.rowCount;
				worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
				currentRow.getCell(2).font = { bold: true, size: 14 };
				currentRow.getCell(2).value = "Control - " + control.name;
				currentRow.getCell(2).fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'FFF2F2F2' }
				};
				currentRow = worksheet.addRow();

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Owner";
				currentRow.getCell(3).value = control.responsible;

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Control type";
				currentRow.getCell(3).value = control.controlType;
				currentRow = worksheet.addRow();

				currentRow = worksheet.addRow();
				currentRow.font = { bold: true };
				currentRow.getCell(2).value = "Probability after";
				currentRow.getCell(3).value = "Consequence after";
				currentRow.getCell(4).value = "Risk after";
				currentRow = worksheet.addRow();

				currentRow.getCell(2).value = ProbabilityLevels[control.probabilityAfter - 1].text;
				currentRow.getCell(3).value = ConsequenceLevels[control.consequenceAfter - 1].text;
				currentRow.getCell(4).value = RiskLevels[control.probabilityAfter - 1][control.consequenceAfter - 1].label;
				cellColor = 'FF' + RiskLevels[control.probabilityAfter - 1][control.consequenceAfter - 1].color.slice(1);
				cellBg = 'FF' + RiskLevels[control.probabilityAfter - 1][control.consequenceAfter - 1].bgColor.slice(1);
				currentRow.getCell(4).fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: cellBg }
				};
				currentRow.getCell(4).font = {
					color: { argb: cellColor }
				};
				currentRow = worksheet.addRow();

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Description";
				currentRow = worksheet.addRow();
				currentRowIdx = worksheet.rowCount;
				worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
				currentRow.getCell(2).value = control.description;
				currentRow.getCell(2).alignment = { wrapText: true };
				currentRow = worksheet.addRow();

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Control measures";
				currentRow = worksheet.addRow();
				currentRowIdx = worksheet.rowCount;
				worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
				currentRow.getCell(2).value = control.measures;
				currentRow.getCell(2).alignment = { wrapText: true };
				currentRow = worksheet.addRow();

				if (control.taskIsWN) {
					currentRow = worksheet.addRow();
					currentRow.getCell(2).font = { bold: true };
					currentRow.getCell(2).value = "Work task";
					currentRow.getCell(3).value = control.taskName;

					currentRow = worksheet.addRow();
					currentRow.getCell(2).font = { bold: true };
					currentRow.getCell(2).value = "Responsible";
					currentRow.getCell(3).value = control.taskResponsible;

					currentRow = worksheet.addRow();
					currentRow.getCell(2).font = { bold: true };
					currentRow.getCell(2).value = "Supporting evidence";
					currentRow.getCell(3).value = "Checked in WorkNodes";

					currentRow = worksheet.addRow();
					currentRow.getCell(2).font = { bold: true };
					currentRow.getCell(2).value = "Task description";
					currentRow = worksheet.addRow();
					currentRowIdx = worksheet.rowCount;
					worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
					currentRow.getCell(2).value = control.taskDescription;
					currentRow.getCell(2).alignment = { wrapText: true };
					currentRow = worksheet.addRow();
				} else {
					currentRow = worksheet.addRow();
					currentRow.getCell(2).font = { bold: true };
					currentRow.getCell(2).value = "Task description";
					currentRow = worksheet.addRow();
					currentRowIdx = worksheet.rowCount;
					worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
					currentRow.getCell(2).value = control.taskDescription;
					currentRow.getCell(2).alignment = { wrapText: true };
					currentRow = worksheet.addRow();

					currentRow = worksheet.addRow();
					currentRow.getCell(2).font = { bold: true };
					currentRow.getCell(2).value = "Responsible";
					currentRow.getCell(3).value = control.taskResponsible;

					currentRow = worksheet.addRow();
					currentRow.getCell(2).font = { bold: true };
					currentRow.getCell(2).value = "Frequency / trigger";
					currentRow.getCell(3).value = control.taskTrigger;

					currentRow = worksheet.addRow();
					currentRow.getCell(2).font = { bold: true };
					currentRow.getCell(2).value = "Supporting evidence";
					currentRow.getCell(3).value = control.supportingEvidence;

					currentRow = worksheet.addRow();
					currentRow.getCell(2).font = { bold: true };
					currentRow.getCell(2).value = "IT dependency";
					currentRow.getCell(3).value = control.depencyType;

					currentRow = worksheet.addRow();
					currentRow.getCell(2).font = { bold: true };
					currentRow.getCell(2).value = "Supporting system";
					currentRow.getCell(3).value = control.supportingSystem;
					currentRow = worksheet.addRow();
				}

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Test instruction";
				currentRow = worksheet.addRow();
				currentRowIdx = worksheet.rowCount;
				worksheet.mergeCells(currentRowIdx, 2, currentRowIdx, 5);
				currentRow.getCell(2).value = control.testInstruction;
				currentRow.getCell(2).alignment = { wrapText: true };
				currentRow = worksheet.addRow();

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Test frequency";
				currentRow.getCell(3).value = control.testFrequency;

				currentRow = worksheet.addRow();
				currentRow.getCell(2).font = { bold: true };
				currentRow.getCell(2).value = "Test responsible";
				currentRow.getCell(3).value = control.tester;
				currentRow = worksheet.addRow();
			}
		}

	}

	riskListPage(ExcelJSWorkbook, riskReport) {
		var worksheet = ExcelJSWorkbook.addWorksheet("Risk summary");

		worksheet.getRow(1).font = { bold: true };
		worksheet.getRow(2).font = { bold: true };
		worksheet.getRow(1).height = 30;
		worksheet.getRow(2).height = 120;

		worksheet.getColumn(2).width = 35;
		worksheet.getColumn(3).width = 55;

		worksheet.getColumn(5).width = 12;
		worksheet.getColumn(6).width = 12;
		worksheet.getColumn(7).width = 12;
		worksheet.getColumn(8).width = 12;
		worksheet.getColumn(9).width = 12;
		worksheet.getColumn(10).width = 12;

		worksheet.getColumn(12).width = 55;

		worksheet.mergeCells("A1:A2");
		worksheet.getCell('A2').value = "Risk ID"
		worksheet.getCell('A2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFE2EFDA' }
		};
		worksheet.getCell('A2').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};


		worksheet.mergeCells("B1:B2");
		worksheet.getCell('B2').value = "Risk name"
		worksheet.getCell('B2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFE2EFDA' }
		};
		worksheet.getCell('B2').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.mergeCells("C1:C2");
		worksheet.getCell('C2').value = "Description"
		worksheet.getCell('C1').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFC0C0C0' }
		};
		worksheet.getCell('C2').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.mergeCells("D1:D2");
		worksheet.getCell('D2').value = "Owner"
		worksheet.getCell('D2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFC0C0C0' }
		};
		worksheet.getCell('D2').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.mergeCells("E1:G1");
		worksheet.getCell('E1').value = "Risk before controls and mitigations"
		worksheet.getCell('E1').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFC0C0C0' }
		};
		worksheet.getCell('E1').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.getCell('E2').value = "Current probability"
		worksheet.getCell('E2').alignment = { textRotation: 90 };
		worksheet.getCell('E2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFE2EFDA' }
		};
		worksheet.getCell('E2').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.getCell('F2').value = "Current consequence"
		worksheet.getCell('F2').alignment = { textRotation: 90 };
		worksheet.getCell('F2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFE2EFDA' }
		};
		worksheet.getCell('F2').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.getCell('G2').value = "Current risk"
		worksheet.getCell('G2').alignment = { textRotation: 90 };
		worksheet.getCell('G2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFC0C0C0' }
		};
		worksheet.getCell('G2').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.mergeCells("H1:J1");
		worksheet.getCell('H1').value = "Risk after controls and mitigations"
		worksheet.getCell('H1').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFC0C0C0' }
		};
		worksheet.getCell('H1').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.getCell('H2').value = "Probability"
		worksheet.getCell('H2').alignment = { textRotation: 90 };
		worksheet.getCell('H2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFE2EFDA' }
		};
		worksheet.getCell('H2').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.getCell('I2').value = "Consequence"
		worksheet.getCell('I2').alignment = { textRotation: 90 };
		worksheet.getCell('I2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFE2EFDA' }
		};
		worksheet.getCell('I2').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.getCell('J2').value = "Risk"
		worksheet.getCell('J2').alignment = { textRotation: 90 };
		worksheet.getCell('J2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFC0C0C0' }
		};
		worksheet.getCell('J2').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.mergeCells("K1:K2");
		worksheet.getCell('K2').value = "Change from preivous review"
		worksheet.getCell('K2').alignment = { textRotation: 90 };
		worksheet.getCell('K2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFE2EFDA' }
		};
		worksheet.getCell('HK1').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFE2EFDA' }
		};
		worksheet.getCell('H2').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		worksheet.mergeCells("L1:L2");
		worksheet.getCell('L2').value = "Comment"
		worksheet.getCell('L2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFE2EFDA' }
		};
		worksheet.getCell('L2').border = {
			top: { style: 'thin' },
			left: { style: 'thin' },
			bottom: { style: 'thin' },
			right: { style: 'thin' }
		};

		var currentRow = worksheet.getRow(3);
		for (let i = 0; i < riskReport.length; i++) {
			var reportLine = riskReport[i];

			var probabilityAfter = reportLine.probability;
			probabilityAfter = reportLine.mitigationReports.reduce((a, b) => Math.min(a, b.probabilityAfter), probabilityAfter,);
			probabilityAfter = reportLine.controlReports.reduce((a, b) => Math.min(a, b.probabilityAfter), probabilityAfter,);

			var consequenceAfter = reportLine.consequence;
			consequenceAfter = reportLine.mitigationReports.reduce((a, b) => Math.min(a, b.consequenceAfter), consequenceAfter,);
			consequenceAfter = reportLine.controlReports.reduce((a, b) => Math.min(a, b.consequenceAfter), consequenceAfter,);

			currentRow.getCell(1).value = reportLine.riskID;
			currentRow.getCell(2).value = reportLine.name;
			currentRow.getCell(3).value = reportLine.description;
			currentRow.getCell(4).value = reportLine.ownerName;

			currentRow.getCell(5).value = ProbabilityLevels[reportLine.probability - 1].text;
			currentRow.getCell(6).value = ConsequenceLevels[reportLine.consequence - 1].text;

			currentRow.getCell(7).value = RiskLevels[reportLine.probability - 1][reportLine.consequence - 1].label;
			var cellColor = 'FF' + RiskLevels[reportLine.probability - 1][reportLine.consequence - 1].color.slice(1);
			var cellBg = 'FF' + RiskLevels[reportLine.probability - 1][reportLine.consequence - 1].bgColor.slice(1);
			currentRow.getCell(7).fill = {
				type: 'pattern',
				pattern: 'solid',
				fgColor: { argb: cellBg }
			};
			currentRow.getCell(7).font = {
				bold: true,
				color: { argb: cellColor }
			};

			//currentRow.getCell(8).value = ProbabilityLevels[reportLine.previousProbability - 1].text;
			//currentRow.getCell(9).value = ConsequenceLevels[reportLine.previousConsequence - 1].text;
			currentRow.getCell(8).value = ProbabilityLevels[probabilityAfter - 1].text;
			currentRow.getCell(9).value = ConsequenceLevels[consequenceAfter - 1].text;

			//currentRow.getCell(10).value = RiskLevels[reportLine.previousProbability - 1][reportLine.previousConsequence - 1].label;
			//var cellColor = 'FF' + RiskLevels[reportLine.previousProbability - 1][reportLine.previousConsequence - 1].color.slice(1);
			//var cellBg = 'FF' + RiskLevels[reportLine.previousProbability - 1][reportLine.previousConsequence - 1].bgColor.slice(1);
			currentRow.getCell(10).value = RiskLevels[probabilityAfter - 1][consequenceAfter - 1].label;
			cellColor = 'FF' + RiskLevels[probabilityAfter - 1][consequenceAfter - 1].color.slice(1);
			cellBg = 'FF' + RiskLevels[probabilityAfter - 1][consequenceAfter - 1].bgColor.slice(1);
			currentRow.getCell(10).fill = {
				type: 'pattern',
				pattern: 'solid',
				fgColor: { argb: cellBg }
			};
			currentRow.getCell(10).font = {
				bold: true,
				color: { argb: cellColor }
			};

			var changeDirection = '→';
			if (reportLine.previousProbability * reportLine.previousConsequence > reportLine.probability * reportLine.consequence) {
				changeDirection = '↘';
			} else if (reportLine.previousProbability * reportLine.previousConsequence < reportLine.probability * reportLine.consequence) {
				changeDirection = '↗';
			}

			currentRow.getCell(11).value = changeDirection;
			currentRow.getCell(11).font = {
				size: 16,
				bold: true
			};

			currentRow = worksheet.addRow();
		}
	}

	render() {
		const footerContent = (
			<div>
				<div style={{ float: 'left' }}>
					
				</div>
				<div style={{ float: 'right' }}>
					<Button label="Close" icon="pi pi-times" onClick={() => this.closeDialog()} className="p-button-secondary" />
					<Button label="Create & Download" icon="pi pi-cloud-download" onClick={() => this.fetchReport()} disabled={this.state.reportName===''} />
				</div>
			</div>
		);


		return (
			<Dialog header="Risk report" visible={this.props.visible}  footer={footerContent}
				modal contentStyle={{ minHeight: '300px', maxWidth:'25rem' }} closable={false} >
				<ConfirmDialog />

				<div style={{ flexWrap: 'wrap', display: 'flex', width: '100%', flexDirection: 'row', flexBasis: 'auto' }}>

					<Card className='rounded' style={{ minWidth: '20rem', marginRight: '1.5rem', marginBottom: '1.5rem' }}>
						<Card.Header>
							<b>Report name</b>
						</Card.Header>
						<Card.Body>
							<div className="p-fluid md:w-20rem">
								<div className="p-field">
									<InputText value={this.state.reportName} maxLength="50" onChange={(e) => { this.setState({ reportName: e.target.value})  }} className="w-full md:w-20rem" />
								</div>

							</div>
						</Card.Body>
					</Card>

					<Card className='rounded' style={{ minWidth: '20rem', marginRight: '1.5rem', marginBottom: '1.5rem' }}>
						<Card.Header>
							<b>Report period</b>
						</Card.Header>
						<Card.Body>
							<div className="p-fluid md:w-20rem">

								<div className="p-field">
									<label className="p-field-label">From date</label>
									<Calendar value={this.state.fromDate} onChange={(e) => null} dateFormat="yy-mm-dd" showIcon  />
								</div>

								<div className="p-field">
									<label className="p-field-label">To date</label>
									<Calendar value={this.state.toDate} onChange={(e) => null} dateFormat="yy-mm-dd"  disabled />
								</div>
								
							</div>
						</Card.Body>
					</Card>
				</div>
			</Dialog>
		);
	}
}
export default (RiskReportDialog);